<template>
  <div class="index-stock">
    <div class="page-title">
      <PageTitle
        class="page-home-title"
        isBack="true"
        link="home"
        fontSize="25"
        icon="fa fa-video-camera"
        title="VideoTeca"
      />
    </div>

    <div class="container-video-teca">
      <div class="side-bar">
        <button
          :class="selectedType == 'codigo' ? 'selected-button' : ''"
          @click="clickBtnBoxSearch('codigo', 'Consulta Por Código')"
        >Consulta Por Código</button>
        <button
          :class="selectedType == 'fita' ? 'selected-button' : ''"
          @click="clickBtnBoxSearch('fita', 'Consulta Por Número Da Fita')"
        >Consulta Por Número Da Fita</button>
        <button
          :class="selectedType == 'obs' ? 'selected-button' : ''"
          @click="clickBtnBoxSearch('obs', 'Consulta Por Observação')"
        >Consulta Por Observação</button>
        <button
          :class="selectedType == 'keyword' ? 'selected-button' : ''"
          @click="clickBtnBoxSearch('keyword', 'Consulta Por Palavra Chave')"
        >Consulta Por Palavra Chave</button>
        <button
          :class="selectedType == 'pendente' ? 'selected-button' : ''"
          @click="clickBtnBoxSearch('pendente', 'Consulta Por Pendente')"
        >Consulta Por Pendente</button>
      </div>
      <div class="main-list">
        <table id="custom-video-teca">
          <tr>
            <th>cod_lanc</th>
            <th>fita</th>
            <th>tipo_fita</th>
            <th>PAL-M</th>
            <th>NTSC</th>
            <th style="min-width: 300px">programa</th>
            <th>codigo</th>
            <th>pendente</th>
            <th>original</th>
            <th>master</th>
            <th>copia</th>
            <th>dublagem</th>
            <th>gravacao</th>
            <th>ch1</th>
            <th>ch2</th>
            <th>ch3</th>
            <th>ch4</th>
            <th>genero</th>
            <th style="min-width: 300px">conteudo</th>
            <th>assunto</th>
            <th>idioma</th>
            <th style="min-width: 300px">obs</th>
            <th style="min-width: 300px">obs2</th>
            <th>tempo</th>
            <th style="min-width: 160px">tc_in</th>
            <th style="min-width: 160px">tc_out</th>
            <th style="min-width: 160px">duracao</th>
            <th style="min-width: 160px">tempo_restante</th>
            <th>artista</th>
            <th style="min-width: 160px">dt edicao</th>
            <th style="min-width: 160px">dt veiculacao</th>
            <th style="min-width: 160px">tp_data</th>
            <th style="min-width: 160px">data</th>
            <th>status</th>
            <th style="min-width: 160px">dt Lanc</th>
            <th>house</th>
            <th>******</th>
            <th>usuario</th>
            <th>MIDIA</th>
          </tr>
          <tr v-for="(videoteca, index) in videotecaData" :key="index">
            <td>{{videoteca.cod_lanc}}</td>
            <td>{{videoteca.fita}}</td>
            <td>{{videoteca.tipo_fita}}</td>
            <td>{{videoteca.pal_m}}</td>
            <td>{{videoteca.ntsc}}</td>
            <td style="min-width: 300px">{{videoteca.programa}}</td>
            <td>{{videoteca.codigo}}</td>
            <td>{{videoteca.pendente}}</td>
            <td>{{videoteca.original}}</td>
            <td>{{videoteca.master}}</td>
            <td>{{videoteca.copia}}</td>
            <td>{{videoteca.dublagem}}</td>
            <td>{{videoteca.gravacao}}</td>
            <td>{{videoteca.ch1}}</td>
            <td>{{videoteca.ch2}}</td>
            <td>{{videoteca.ch3}}</td>
            <td>{{videoteca.ch4}}</td>
            <td>{{videoteca.genero}}</td>
            <td style="min-width: 300px">{{videoteca.conteudo}}</td>
            <td>{{videoteca.assunto}}</td>
            <td>{{videoteca.idioma}}</td>
            <td style="min-width: 300px">{{videoteca.obs}}</td>
            <td style="min-width: 300px">{{videoteca.obs2}}</td>
            <td>{{videoteca.tempo}}</td>
            <td style="min-width: 160px">{{videoteca.tc_in}}</td>
            <td style="min-width: 160px">{{videoteca.tc_out}}</td>
            <td style="min-width: 160px">{{videoteca.duracao}}</td>
            <td style="min-width: 160px">{{videoteca.tempo_restante}}</td>
            <td>{{videoteca.artista}}</td>
            <td style="min-width: 160px">{{videoteca.dtEdicao}}</td>
            <td style="min-width: 160px">{{videoteca.dtVeiculacao}}</td>
            <td style="min-width: 160px">{{videoteca.tp_data}}</td>
            <td style="min-width: 160px">{{videoteca.data}}</td>
            <td>{{videoteca.status}}</td>
            <td style="min-width: 160px">{{videoteca.dtLanc}}</td>
            <td>{{videoteca.house}}</td>
            <td>{{videoteca.security}}</td>
            <td>{{videoteca.usuario}}</td>
            <td>{{videoteca.midia}}</td>
          </tr>
        </table>
      </div>
    </div>
    <!-- The Modal -->
    <div id="myModal" class="modal">
      <!-- Modal content -->
      <div class="modal-content">
        <div class="modal-header">
          <h4>{{selectedText}}</h4>
          <span class="close" @click="closeModel">&times;</span>
        </div>
        <form @submit.prevent="clickSearch">
          <div class="modal-body">
            <label for="inputvideoteca">Inserir Valor Do Parâmetro</label>
            <input
              name="inputvideoteca"
              ref="focussearch"
              id="input-video-teca"
              v-model="inputSearch"
              type="text"
            />
          </div>
          <div class="modal-footer">
            <button class="button-search-video-teca">Pesquisar</button>
          </div>
        </form>
      </div>
    </div>
    <!-- fim -->
  </div>
</template>

<script>
//components
import PageTitle from "@/components/template/PageTitle";
import { baseApiUrl } from "@/global";
import axios from "axios";

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  let modal = document.getElementById("myModal");
  if (event.target == modal) {
    modal.style.display = "none";
  }
};

export default {
  name: "IndexCedoc",
  components: { PageTitle },
  data() {
    return {
      videotecaData: [],
      selectedType: null,
      selectedText: null,
      inputSearch: ""
    };
  },
  methods: {
    // botão de pesquisar
    async clickSearch() {
      if (this.inputSearch == "" || this.inputSearch.length == 0) {
        this.showMessage(
          "Digite o valor do parâmetro para pesquisar.",
          "danger"
        );
        return;
      }

      this.$vs.loading({ text: "Pesquisando..." });

      if (this.selectedType == "codigo") {
        await this.listByCodigo(this.inputSearch);
      } else if (this.selectedType == "fita") {
        await this.listByFita(this.inputSearch);
      } else if (this.selectedType == "obs") {
        await this.listByObs(this.inputSearch);
      } else if (this.selectedType == "keyword") {
        await this.listByKeyWord(this.inputSearch);
      } else if (this.selectedType == "pendente") {
        await this.listByPendente(this.inputSearch);
      }
    },
    // fim

    // clique no botão de tipo
    clickBtnBoxSearch(type, text) {
      this.selectedType = type;
      this.selectedText = text;
      this.inputSearch = "";
      this.openModel();
      this.$refs.focussearch.focus();
    },
    // fim

    //lista por código
    async listByCodigo(codigo) {
      await axios.get(`${baseApiUrl}/videoteca/codigo/${codigo}`).then(resp => {
        this.videotecaData = resp.data;
        if (this.videotecaData.length == 0) {
          this.showMessage("Pesquisa não retornou nenhum item!", "danger");
        } else {
          this.closeModel();
        }
        this.$vs.loading.close();
      });
    },
    // fim
    // lista por fita
    async listByFita(fita) {
      await axios.get(`${baseApiUrl}/videoteca/fita/${fita}`).then(resp => {
        this.videotecaData = resp.data;
        if (this.videotecaData.length == 0) {
          this.showMessage("Pesquisa não retornou nenhum item!", "danger");
        } else {
          this.closeModel();
        }
        this.$vs.loading.close();
      });
    },
    // fim

    // lista por observação
    async listByObs(obs) {
      let observation = {
        param: obs
      };

      await axios
        .post(`${baseApiUrl}/videoteca/obs`, observation)
        .then(resp => {
          this.videotecaData = resp.data;
          if (this.videotecaData.length == 0) {
            this.showMessage("Pesquisa não retornou nenhum item!", "danger");
          } else {
            this.closeModel();
          }
          this.$vs.loading.close();
        });
    },
    // fim

    // lista por palavra chave
    async listByKeyWord(keyword) {
      let keyWord = {
        param: keyword
      };

      await axios
        .post(`${baseApiUrl}/videoteca/key-word`, keyWord)
        .then(resp => {
          this.videotecaData = resp.data;
          if (this.videotecaData.length == 0) {
            this.showMessage("Pesquisa não retornou nenhum item!", "danger");
          } else {
            this.closeModel();
          }
          this.$vs.loading.close();
        });
    },
    // fim

    // lista por pendente
    async listByPendente(pendente) {
      let penVideoTeca = {
        param: pendente
      };

      await axios
        .post(`${baseApiUrl}/videoteca/pendente`, penVideoTeca)
        .then(resp => {
          this.videotecaData = resp.data;
          if (this.videotecaData.length == 0) {
            this.showMessage("Pesquisa não retornou nenhum item!", "danger");
          } else {
            this.closeModel();
          }
          this.$vs.loading.close();
        });
    },
    // fim

    // abre o modal
    openModel() {
      let modal = document.getElementById("myModal");
      modal.style.display = "block";
    },
    // fecha o modal
    closeModel() {
      let modal = document.getElementById("myModal");
      let span = document.getElementsByClassName("close")[0];
      modal.style.display = "none";
    },
    showMessage(message, type) {
      this.$vs.notify({
        title: "Aviso",
        text: message,
        color: type
      });
    }
  },
  created() {}
};
</script>

<style src="./style.css">
</style>